<template>
  <div class="iframe_wrapper">
  <div class="search_panel">
    <div class="search_header">
      <div class="search_eyebrow">● ZNAJDŹ AUTO MARZEŃ</div>
      <h3>Znajdź swój wymarzony <span class="accent">samochód</span></h3>
    </div>
    <div class="car_type">
      <div class="select_box">
        <label class="field_label">Marka</label>
        <multiselect
          v-model="selected.car_brand"
          :options="car_brands"
          class="dropdown"
          :searchable="true"
          :show-labels="false"
          placeholder="Wybierz markę"
          track-by="name"
          label="name"
          @update:modelValue="getModelsByMake"
        ></multiselect>
      </div>
      <div class="select_box">
        <label class="field_label">Model</label>
        <multiselect
          v-model="selected.car_model"
          :options="car_models"
          class="dropdown"
          :searchable="true"
          :show-labels="false"
          placeholder="Wybierz model"
        ></multiselect>
      </div>
      <div class="select_box year_row">
        <div class="year_group">
          <label class="field_label">Rok od</label>
          <input
            type="number"
            v-model.number="selected.year_from"
            placeholder="2018"
            class="text_input"
            min="1970"
            max="2030"
          />
        </div>
        <div class="year_group">
          <label class="field_label">Rok do</label>
          <input
            type="number"
            v-model.number="selected.year_to"
            placeholder="2024"
            class="text_input"
            min="1970"
            max="2030"
          />
        </div>
      </div>
      <div class="select_box">
        <label class="field_label">Skrzynia biegów</label>
        <select
          class="text_input select_native"
          :class="{ is_placeholder: selected.transmission === '' }"
          v-model="selected.transmission"
        >
          <option value="">Dowolna</option>
          <option value="AT">Automatyczna</option>
          <option value="MT">Manualna</option>
        </select>
      </div>
    </div>
    <div class="search_btn">
      <button name="search_button" class="search_button" @click="search">
        Szukaj →
      </button>
    </div>
  </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
import { goToResults } from "@/utils/embed";
export default {
  name: "SearchBar",
  components: { Multiselect },
  data() {
    return {
      selected: {
        car_brand: null,
        car_model: null,
        year_from: null,
        year_to: null,
        transmission: "",
      },
      car_brands: [],
      car_models: [],
    };
  },
  beforeMount() {
    this.getDictionarys();
  },
  methods: {
    search() {
      const params = new URLSearchParams();
      const brand = this.selected.car_brand;
      if (brand)
        params.set("car_brand", typeof brand === "object" ? brand.name : brand);
      if (this.selected.car_model) params.set("car_model", this.selected.car_model);
      if (this.selected.year_from) params.set("year_from", this.selected.year_from);
      if (this.selected.year_to) params.set("year_to", this.selected.year_to);
      if (this.selected.transmission)
        params.set("transmission", this.selected.transmission);
      goToResults(this.$router, Object.fromEntries(params));
    },
    async getDictionarys() {
      try {
        var { data } = await axios.get(
          process.env.VUE_APP_API_HOST + "/japan/get-makes",
          { headers: { "X-API-Key": process.env.VUE_APP_API_KEY } }
        );
        var makes = [];
        var makesData = data.result || data;
        for (var i in makesData) {
          if (makesData[i]["make"] != "")
            makes.push({ name: makesData[i]["make"], id: makesData[i]["id"] });
        }
        this.car_brands = makes;

        var { data: modelsData } = await axios.get(
          process.env.VUE_APP_API_HOST + "/japan/get-models",
          { headers: { "X-API-Key": process.env.VUE_APP_API_KEY } }
        );
        var models = [];
        var results = modelsData.result || [];
        for (var j in results) {
          if (results[j]["model"] != "") models.push(results[j]["model"]);
        }
        this.car_models = models;
      } catch (error) {
        console.error("Failed loading Japan makes/models", error);
      }
    },
    async getModelsByMake(selectedBrand) {
      const makerName = selectedBrand?.name;
      if (!makerName) {
        this.car_models = [];
        return;
      }
      try {
        var { data } = await axios.get(
          process.env.VUE_APP_API_HOST + "/japan/get-models-by-make",
          {
            params: { maker: makerName },
            headers: { "X-API-Key": process.env.VUE_APP_API_KEY },
          }
        );
        var models = [];
        var results = data.result || [];
        for (var i in results) {
          var modelName = results[i]["name"] || results[i]["model"];
          if (modelName) models.push(modelName);
        }
        this.car_models = models;
      } catch (error) {
        console.error("Failed loading Japan models for maker", error);
      }
    },
  },
};
</script>

<!-- Multiselect dark overrides — global so they reach the component's shadow DOM -->
<style>
.search_panel .multiselect__tags {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 0 !important;
  padding: 8px 40px 0 12px !important;
  min-height: 44px !important;
  box-shadow: none !important;
}
.search_panel .multiselect__input {
  background: transparent !important;
  color: #fff !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 14px !important;
  padding: 0 !important;
  margin: 0 !important;
}
.search_panel .multiselect__single {
  background: transparent !important;
  color: #fff !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding: 0 !important;
}
.search_panel .multiselect__placeholder {
  color: rgba(255, 255, 255, 0.28) !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding-top: 1px !important;
}
.search_panel .multiselect__select {
  height: 44px !important;
  top: 0 !important;
  transform: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}
.search_panel .multiselect__select::before {
  position: static !important;
  top: auto !important;
  right: auto !important;
  border-color: rgba(255, 255, 255, 0.4) transparent transparent !important;
}
.search_panel .multiselect__content-wrapper {
  background: #1c1c1c !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-top: none !important;
  border-radius: 0 !important;
}
.search_panel .multiselect__option {
  font-family: "DM Sans", sans-serif !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  background: transparent !important;
}
.search_panel .multiselect__option--highlight,
.search_panel .multiselect__option--highlight::after {
  background: rgba(210, 31, 31, 0.2) !important;
  color: #fff !important;
}
.search_panel .multiselect__option--selected,
.search_panel .multiselect__option--selected::after {
  background: rgba(210, 31, 31, 0.35) !important;
  color: #fff !important;
  font-weight: 600 !important;
}
.search_panel .multiselect__option--selected.multiselect__option--highlight,
.search_panel
  .multiselect__option--selected.multiselect__option--highlight::after {
  background: rgba(210, 31, 31, 0.45) !important;
  color: #fff !important;
}
.search_panel .multiselect__content-wrapper::-webkit-scrollbar {
  width: 4px;
}
.search_panel .multiselect__content-wrapper::-webkit-scrollbar-track {
  background: #1c1c1c;
}
.search_panel .multiselect__content-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
}
</style>

<style scoped>
.iframe_wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.search_panel {
  width: 620px;
  height: 600px;
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.07);
  padding: 24px 32px;
  font-family: "DM Sans", sans-serif;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.search_eyebrow {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #d21f1f;
  margin-bottom: 10px;
}

h3 {
  font-family: "Space Grotesk", sans-serif;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 18px;
  line-height: 1.15;
}

.accent {
  color: #d21f1f;
}

.car_type {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.select_box {
  width: 100%;
}

.select_box .dropdown {
  width: 100% !important;
}

.field_label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.35);
  margin-bottom: 7px;
}

.year_row {
  display: flex;
  gap: 10px;
}

.year_group {
  flex: 1;
  min-width: 0;
}

.text_input {
  width: 100%;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
  appearance: none;
  -webkit-appearance: none;
}

.text_input:focus {
  border-color: rgba(255, 255, 255, 0.3);
}

.text_input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.select_native {
  cursor: pointer;
}

.select_native.is_placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.select_native option {
  background: #1c1c1c;
  color: #fff;
}

/* Hide number input spin buttons */
.text_input[type="number"]::-webkit-inner-spin-button,
.text_input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.text_input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.search_btn {
  margin-top: 0;
}

.search_button {
  width: 100%;
  padding: 13px 24px;
  background: #d21f1f;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  letter-spacing: 0.01em;
  transition: background 0.15s, transform 0.1s;
}

.search_button:hover {
  background: #b81a1a;
}

.search_button:active {
  transform: scale(0.98);
}
</style>
